import { useEffect, useState } from "react";

/** Matches Tailwind `md` (768px): true when viewport is narrower than `md`. */
export const MOBILE_NAV_MEDIA_QUERY = "(max-width: 767px)";

export function useMobileNavBreakpoint(): boolean {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== "undefined"
      ? window.matchMedia(MOBILE_NAV_MEDIA_QUERY).matches
      : false
  );

  useEffect(() => {
    const mq = window.matchMedia(MOBILE_NAV_MEDIA_QUERY);
    const onChange = () => setIsMobile(mq.matches);
    onChange();
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  return isMobile;
}
